import React from 'react';
import PropTypes from 'prop-types';
import CardStyles from './cardStyles';

const Card = props => {
  return (
    <CardStyles {...props} selected={props.selected}>
      {props.children}
    </CardStyles>
  );
};

Card.propTypes = {
  children: PropTypes.node,
  selected: PropTypes.bool,
};

Card.defaultProps = {
  children: undefined,
  selected: undefined,
};

const CardImage = props => {
  return (
    <CardStyles.ImageWrapperStyles active={props.active}>
      <CardStyles.ImageStyles src={props.src} />
    </CardStyles.ImageWrapperStyles>
  );
};

CardImage.propTypes = {
  src: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

CardImage.defaultProps = {
  active: false,
};

const CardData = props => {
  return <CardStyles.DataStyles>{props.children}</CardStyles.DataStyles>;
};

CardData.propTypes = {
  children: PropTypes.node,
};

CardData.defaultProps = {
  children: undefined,
};

Card.Image = CardImage;
Card.Data = CardData;

export default Card;
